import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The path of the nearest SubViewport above a node, null at the root viewport. A Camera3D joins the
 * nearest viewport above it (`camera_3d.cpp`, `NOTIFICATION_ENTER_WORLD`: `get_viewport()`), so a
 * world elects each viewport's camera among the cameras that name it.
 */
import { createContext, useContext } from 'react';
const EnclosingViewportContext = createContext(null);
EnclosingViewportContext.displayName = 'EnclosingViewportContext';
export function EnclosingViewportProvider({ path, children }) {
    return _jsx(EnclosingViewportContext.Provider, { value: path, children: children });
}
/** @canonical The viewport a node renders in */
export function useEnclosingViewportPath() {
    return useContext(EnclosingViewportContext);
}
//# sourceMappingURL=EnclosingViewportContext.js.map